(function () {
    'use strict';
    $(document).ready(function () {

        // Smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top - 80
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        ScrollTrigger.matchMedia({
            "(min-width: 768px)": function() {
                ScrollTrigger.create({
                    trigger: ".header .pin-menu",
                    start: "top top",
                    end: "+=1000000000",
                    toggleClass: {targets: ".header .pin-menu", className: "fixed"}
                });
            }
        });

        //Menu mobile toggle
        $(".menu-toggle").click(function(){
            $('#main-menu').fadeToggle();
            $(this).toggleClass("open");
        });

        //Search trigger
        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

        //Linki posiadające podmenu - wyłączenie domyślnego zachowania

        $("#site-menu > li.menu-item-has-children > a").click(function (e) {
            e.preventDefault();
        });

        $("#site-menu li.menu-item-has-children > ul," +
            "#site-menu li.menu-item-has-children > ul > li").click(function (e) {
            e.stopPropagation();
        });

        //Mainmenu - level 0
        $("#site-menu > li.menu-item-has-children").click(function () {
            var $wnd = window.innerWidth;

            if (window.matchMedia("(min-width: 992px)").matches) {

                $(this).children('ul').fadeToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });

                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                } else {
                    $(this).addClass('open');
                }

                $(this).siblings('li').removeClass('open');
                $(this).siblings('li').children('ul').fadeOut();

            } else {

                $(this).children('ul').slideToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });
                $(this).siblings('li').children('ul').slideUp();

            }
        });


        if (window.matchMedia("(min-width: 992px)").matches) {
            $(window).click(function () {
                $('#site-menu > li.menu-item-has-children').removeClass('open');
                $('#site-menu > li.menu-item-has-children').siblings('li').removeClass('open');
                $('#site-menu > li.menu-item-has-children').siblings('li').children('ul').fadeOut();
            });

            $('#site-menu > li.menu-item-has-children').click(function (event) {
                event.stopPropagation();
            });
        }
    });
}(jQuery));
